export class OnboardingLeaderboard {
  id: string
  userId: string
  completionRate: number

  constructor(data: Partial<OnboardingLeaderboard>) {
    Object.assign(this, data)
    this.id = data.userId
  }
}
